import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Button } from "@mui/material";

interface Props {
  isDialogOpened: boolean;
  handleConfirmDialog: any;
  handleCloseDialog: any;
  message?: any;
  disableNo?: boolean;
  dilogTitle?: string;
  actionBtn?: string;
  cancleBtn?: string;
}
export function DilogBox(props: Props) {
  return (
    <Dialog open={props.isDialogOpened}>
      {props.dilogTitle && <DialogTitle>{props.dilogTitle}</DialogTitle>}
      <DialogContent>
        <DialogContentText>{props.message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={props.handleConfirmDialog}>
          {props.actionBtn ? <>{props.actionBtn}</> : <>{`Yes`}</>}
        </Button>
        {!props.disableNo && (
          <Button
            variant="contained"
            color="error"
            onClick={props.handleCloseDialog}
          >
            {props.cancleBtn ? <>{props.cancleBtn}</> : <>{`No`}</>}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
export default DilogBox;
